import type { ParsedUrlQuery } from 'querystring'
import type { Experiments } from '@mc/experiments'
import { FORCE_FLAG_PREFIX, deserializeBucketMap } from '@mc/next-growthbook'
import {
  DENSITY_PACING_BUCKETS,
  DENSITY_PACING_FLAG,
} from '../experiments/jar-3638_v1_density-pacing'
import {
  ORCHESTRATOR_MODEL_BUCKETS,
  ORCHESTRATOR_MODEL_FLAG,
} from '../experiments/jar-4217-orchestrator-model'

type ForceableFlags = Readonly<Record<string, readonly string[]>>

// Flags whose bucket `?exp_<flag>=<bucket>` (or the `mc_gb_force` cookie it
// sets) can force without a GrowthBook experiment rule. The URL is public,
// so list only flags where any learner may safely self-select every bucket.
export const DARK_FORCEABLE_FLAGS: ForceableFlags = {
  [ORCHESTRATOR_MODEL_FLAG]: ORCHESTRATOR_MODEL_BUCKETS,
  [DENSITY_PACING_FLAG]: DENSITY_PACING_BUCKETS,
}

export const applyDarkForcedBuckets = (
  experiments: Experiments,
  forceCookie: string | undefined,
  query: ParsedUrlQuery,
  forceable: ForceableFlags = DARK_FORCEABLE_FLAGS,
): Experiments => {
  const cookieBuckets = deserializeBucketMap(forceCookie)
  const overrides: Experiments = {}
  Object.entries(forceable).forEach(([flag, buckets]) => {
    if (!(flag in experiments)) return
    const fromQuery = query[`${FORCE_FLAG_PREFIX}${flag}`]
    const requested =
      typeof fromQuery === 'string' ? fromQuery : cookieBuckets.get(flag)
    if (requested && buckets.includes(requested)) {
      overrides[flag] = requested
    }
  })
  return { ...experiments, ...overrides }
}
